export const selectProfileSelected = (state) => state.profileSelected;
export const selectTitleProfile = (state) => state.titleProfile;
export const selectOnChangeNavigation = (state) => state.onChangeNavigation;
/**
 * Открыть модальное окно "Профиль пользователя"
 * @param state
 * @returns {(function(): *)|*}
 */
export const selectorOpenProfileDrawer = (state) => state.openProfileDrawer;
/**
 * Закрыть модальное окно "Профиль пользователя"
 * @param state
 * @returns {(function(): *)|*}
 */
export const selectorCloseProfileDrawer = (state) => state.closeProfileDrawer;
